import React, { FC } from 'react';
import { FormattedMessage } from 'react-intl';
import { Hyperlink } from '../../../../Hyperlink';
import { getPageName } from '../../../../../utils/pageName';
import { RestrictedModalLayout } from '../RestrictedModalLayout';
import {
  withLoginModal,
  WithLoginModalProps,
} from '../../../../../login/withLoginModal';

type Props = {
  closeModal: () => void;
  source: string;
} & WithLoginModalProps;

export const RawCommentariesRestrictedModal: FC<Props> = ({
  closeModal,
  openLoginModal,
  source,
}) => {
  const sourcePage: string = getPageName();

  const openLoginCta = () => {
    closeModal();
    openLoginModal();
  };

  return (
    <RestrictedModalLayout closeModal={closeModal} source={source}>
      <i className="material-icons icons__lock restricted-modal__big-icon" />
      <div className="restricted-modal__title">
        <FormattedMessage id="public/CommentariesRestrictedModal.tsx/1" />
      </div>
      <span className="restricted-modal__subtitle">
        <FormattedMessage
          id="public/CommentariesRestrictedModal.tsx/2"
          values={{ br: <br /> }}
        />
      </span>
      <Hyperlink
        className="button large brand restricted-modal__start-button"
        href={`/inscription?source=${source}&sourcePage=${sourcePage}`}
      >
        <i className="material-icons icons__arrow_forward restricted-modal__start-button__arrow" />
        <FormattedMessage id="public/CommentariesRestrictedModal.tsx/3" />
      </Hyperlink>
      <div className="restricted-modal__bottom">
        <FormattedMessage id="public/CommentariesRestrictedModal.tsx/4" />
        <button
          type="button"
          className="restricted-modal__bottom__link"
          onClick={openLoginCta}
        >
          <FormattedMessage id="public/CommentariesRestrictedModal.tsx/5" />
        </button>
      </div>
    </RestrictedModalLayout>
  );
};

export const CommentariesRestrictedModal = withLoginModal(
  RawCommentariesRestrictedModal,
);
